/* eslint-disable */
import React from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import config from './config'

/** checkarray / config 叶子：RBAC 为 moduleCodes、buttonCodes；配置里按钮码列表可简写键 b */
const CONFIG_LEAF_CANDIDATES = (dataType) => {
  if (dataType === 'moduleCodes') {
    return ['moduleCodes']
  }
  if (dataType === 'buttonCodes') {
    return ['buttonCodes']
  }
  return [dataType]
}

const Permission = (props) => {
  const { children, rootPath = [], checkType = 'and' } = props
  // checkarray 与 config 第四层字段对应：moduleCodes、buttonCodes（RBAC）、dataRes、dataRes2（业务态）等
  const allowed = (path, dataType) => {
    const pathOk = Array.isArray(path) && path.length > 0
    if (!pathOk) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn(
          'PermissionA5: pathitem 须为非空数组，当前无效，按无权限处理',
          { rootPath, pathitem: path, dataType }
        )
      }
      return false
    }
    const raw = props[dataType]
    const formatRoles = Array.isArray(raw) ? raw : []
    let allowedRoles
    for (const leaf of CONFIG_LEAF_CANDIDATES(dataType)) {
      const v = R.path([rootPath, ...path, leaf], config)
      if (Array.isArray(v)) {
        allowedRoles = v
        break
      }
    }
    if (!allowedRoles || !Array.isArray(allowedRoles)) {
      console.error('Permission组件提醒: 无法找到权限路径,权限操作则不返回', [rootPath, ...path, dataType])
      return false
    }
    return allowedRoles.some(role => formatRoles.includes(role))
  }

  const renderChildren = children => {
    return React.Children.map(children, child=> {
      if (!React.isValidElement(child)) { return child }

      const arrayAllowed = child.props.checkarray && child.props.checkarray.map(c => {
        return allowed(child.props.pathitem, c)
      })
      if (checkType === 'and' && arrayAllowed && arrayAllowed.includes(false)) {
        return null
      }

      if (checkType === 'or'  && arrayAllowed && !arrayAllowed.includes(true)) {
        return null
      }

      if (child.props.children) {
        const children = renderChildren(child.props.children)
        child = React.cloneElement(child, {
          children: children.length === 1 ? children[0] : children
        })
      }

      return child
    })
  }
  return renderChildren(children)
}

const mapStateToProps = state => ({
  moduleCodes: state.app.permissionCodes.moduleCodes,
  buttonCodes: state.app.permissionCodes.buttonCodes
})

export default connect(mapStateToProps)(Permission)

// checkarray：'moduleCodes' | 'buttonCodes' | 'dataRes' | 'dataRes2'
// moduleCodes / buttonCodes 默认由 connect 注入；也可由父组件传 props 覆盖

// checkType: 'or' | 'and'（默认 and）

// **** ----------------------------------------

// <Permission
//  rootPath='dispatchPage'
//  dataRes={[record.executeStatus]}
// >
//  <span pathitem={['dispatch', 'a']} checkarray={['dataRes']}>...</span>
//  <span pathitem={['some', 'btn']} checkarray={['buttonCodes']}>...</span>
// </Permission>

// -------------------------------------------**
